import React from 'react';
import TableSortInputFilter from 'components/customComponents/Controls/tableSortInputFilter';
import { FmlxButton } from 'fmlx-common-ui';
import RMTable from 'components/customComponents/Controls/RMTable';

const ConflictedIngredient: React.FC<{
  values: any[];
  conflictIngSelectedId: number;
  checkBoxSelectionChange(selectedItems: any[]): void;
  addRestAsNewClick(): any;
  status: string;
}> = ({
  values,
  conflictIngSelectedId,
  status,
  checkBoxSelectionChange,
  addRestAsNewClick,
}) => {
  const columns: {
    accessor: string;
    Header: string;
    Filter?: (event: any) => JSX.Element;
    className?: string;
  }[] = [
    {
      accessor: 'name',
      Header: 'Name',
      Filter: handleTableFilter(true, 'Name'),
    },
    {
      accessor: 'status',
      Header: '',
      className: 'ingredient-list-status',
    },
  ];

  return (
    <div id="conflictingingredient-wrapper" className="ingredient-conflicted-general">
      <div id="conflictingingredient-header" className="d-flex justify-content-between mb-1">
        <b id="conflictingingredient-title">Conflict Ingredients</b>
        <FmlxButton
          id="conflictingingredient-button-addrest"
          label="ADD REST AS NEW"
          onClick={addRestAsNewClick}
          type={FmlxButton.Type.POSITIVE}
          size={FmlxButton.Size.SMALL}
        />
      </div>
      <div id="conflictingingredient-status-row" className="d-flex justify-content-between">
        <b id="conflictingingredient-status-label">Status:</b>
        <div id="conflictingingredient-status-value" className="ms-1">{status}</div>
      </div>
      {values && (
        <div id="conflictingingredient-table-wrapper" className="ingredient-table-div border-box mt-1">
          <RMTable
            columns={columns}
            data={values}
            selectedIds={[conflictIngSelectedId]}
            onCheckboxSelectionChange={checkBoxSelectionChange}
            enableMultiSelection={false}
          />
        </div>
      )}
    </div>
  );
};
const handleTableFilter = (filterable: boolean, filterTitle: string) => (event: any) =>
  <TableSortInputFilter event={event} title={filterTitle} showSearchInput={filterable} />;

export default ConflictedIngredient;
